export default __webpack_public_path__ + "static/media/background-table.5d1ee1b4.png";